import { requireModule } from 'auth/guards';
import { MODULES } from 'auth/permissions';
import { attendanceRoutes } from './attendance/attendance.routes';
import { employeeRoutes } from './employees/employees.routes';
import { feedbackRoutes } from './feedback/feedback.routes';
import { payrollRoutes } from './payroll/payroll.routes';
import { peopleRoutes } from './people/people.routes';
import AdminModulePage from './pages/AdminModule';
import { vouchersRoutes } from './vouchers/vouchers.routes';

export const hrRoutes = [
  {
    path: '/admin-module',
    element: <AdminModulePage />,
    loader: requireModule(MODULES.EMPLOYEES),
  },
  ...employeeRoutes,
  ...attendanceRoutes,
  ...vouchersRoutes,
  ...feedbackRoutes,
  ...payrollRoutes,
  ...peopleRoutes,
];
